import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  BRANDS_REQUESTED,
  BRANDS_SUCCESS,
} from '../types';

export const brandsRequested = () => {
  return {
    type: BRANDS_REQUESTED
  }
};

export const brandsSuccess = (settings) => {
  return {
    type: BRANDS_SUCCESS,
    payload: settings
  }
};

export const getBrands = (signedPayload) => {
  return (dispatch) => {
    dispatch(brandsRequested());

    let endPoint = Config.baseUrl + Config.brands;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(brandsSuccess(response.data));
      })
  }
}
